module.exports = __webpack_public_path__ + "static/media/microphone.148bd032.svg";